/*
 * Nawigacja po galerii na karcie produktu.
 *
 * Układ „duże zdjęcie + miniatury" z Dawna nie ma żadnego sposobu na przejście
 * do następnego zdjęcia poza kliknięciem w miniaturę. Przy 11 zdjęciach kolumna
 * miniatur jest dłuższa niż okno, więc do ostatnich trzeba było przewijać stronę.
 *
 * Dokładamy strzałki na kadrze i obsługę klawiszy ←/→. Przełączanie robimy
 * KLIKAJĄC miniaturę, a nie wywołując wewnętrzne metody `media-gallery` —
 * dzięki temu Dawn sam ogarnia stan, wariant, zoom i dostępność.
 */
(function () {
  function wepnij(galeria) {
    if (galeria.dataset.galeriaGotowa) return;

    var listaMiniatur = galeria.querySelector('.thumbnail-list');
    if (!listaMiniatur) return; // układ bez miniatur — nie ma czym sterować

    var kadr = galeria.querySelector('.product__media-list');
    if (!kadr) return;
    galeria.dataset.galeriaGotowa = '1';

    function miniatury() {
      return Array.prototype.slice.call(listaMiniatur.querySelectorAll('.thumbnail'));
    }

    function idAktywnej(lista) {
      for (var i = 0; i < lista.length; i++) {
        if (lista[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function przejdz(krok) {
      var lista = miniatury();
      if (lista.length < 2) return;
      var i = idAktywnej(lista) + krok;
      if (i < 0) i = lista.length - 1;
      if (i >= lista.length) i = 0;
      lista[i].click();
      // dosuwamy miniaturę do widoku — kolumna ma własne przewijanie
      var rodzic = lista[i].closest('.thumbnail-list__item') || lista[i];
      if (rodzic.scrollIntoView) rodzic.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      odswiezStrzalki();
    }

    var przyciski = {};
    ['prev', 'next'].forEach(function (kierunek) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'galeria-strzalka galeria-strzalka--' + kierunek;
      b.setAttribute('aria-label', kierunek === 'prev' ? 'Poprzednie zdjęcie' : 'Następne zdjęcie');
      b.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
        (kierunek === 'prev' ? 'M15 5 8 12l7 7' : 'M9 5l7 7-7 7') +
        '"/></svg>';
      b.addEventListener('click', function () {
        przejdz(kierunek === 'prev' ? -1 : 1);
      });
      przyciski[kierunek] = b;
      kadr.parentNode.appendChild(b);
    });

    /*
     * Galeria zawija się w kółko, więc strzałki nigdy nie są zablokowane —
     * ukrywamy je tylko wtedy, gdy zdjęcie jest jedno.
     */
    function odswiezStrzalki() {
      var jedno = miniatury().length < 2;
      przyciski.prev.hidden = jedno;
      przyciski.next.hidden = jedno;
    }
    odswiezStrzalki();

    // strzałki klawiatury działają, gdy kursor jest nad galerią albo ma ona fokus
    var aktywna = false;
    galeria.addEventListener('mouseenter', function () { aktywna = true; });
    galeria.addEventListener('mouseleave', function () { aktywna = false; });
    galeria.addEventListener('focusin', function () { aktywna = true; });

    document.addEventListener('keydown', function (e) {
      if (!aktywna) return;
      var wPolu = /^(INPUT|TEXTAREA|SELECT)$/.test((e.target.tagName || '').toUpperCase());
      if (wPolu) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); przejdz(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); przejdz(1); }
    });

    // po zmianie wariantu Dawn przebudowuje listę miniatur
    new MutationObserver(odswiezStrzalki).observe(listaMiniatur, { childList: true, subtree: true });

    /*
     * Kropki pod kadrem — zamiennik miniatur na telefonie.
     * Miniatury są tam wyłączone w ustawieniach sekcji („Miniatury na telefonie:
     * ukryj"), a galerię przewija się palcem. Kropki pokazują, ile jest zdjęć
     * i na którym jesteśmy; pozycję czytamy z `scrollLeft` samej karuzeli,
     * więc działają zarówno przy przesunięciu palcem, jak i po kliknięciu.
     */
    var kropki = document.createElement('div');
    kropki.className = 'galeria-kropki';
    kropki.setAttribute('aria-hidden', 'true');

    function slajdy() {
      return Array.prototype.slice.call(kadr.querySelectorAll('.product__media-item'));
    }

    function zbudujKropki() {
      var ile = slajdy().length;
      kropki.innerHTML = '';
      if (ile < 2) return;
      for (var i = 0; i < ile; i++) {
        (function (nr) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'galeria-kropki__kropka' + (nr === 0 ? ' jest-aktywna' : '');
          b.addEventListener('click', function () {
            var s = slajdy()[nr];
            if (s) kadr.scrollTo({ left: s.offsetLeft - kadr.offsetLeft, behavior: 'smooth' });
          });
          kropki.appendChild(b);
        })(i);
      }
    }

    function odswiezKropki() {
      var lista = slajdy();
      if (!lista.length) return;
      var szerokosc = lista[0].getBoundingClientRect().width || 1;
      var teraz = Math.round(kadr.scrollLeft / szerokosc);
      var guziki = kropki.querySelectorAll('.galeria-kropki__kropka');
      for (var i = 0; i < guziki.length; i++) {
        guziki[i].classList.toggle('jest-aktywna', i === teraz);
      }
    }

    zbudujKropki();
    kadr.parentNode.appendChild(kropki);

    // kropki mają siedzieć na dole ZDJĘCIA, nie na dole wrappera
    function ustawWysokoscKropek() {
      var wysokosc = kropki.offsetHeight || 8;
      kropki.style.setProperty('--kropki-gora', (kadr.offsetTop + kadr.offsetHeight - wysokosc - 14) + 'px');
    }
    ustawWysokoscKropek();
    window.addEventListener('resize', ustawWysokoscKropek, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(ustawWysokoscKropek).observe(kadr);

    var czekaKropki = false;
    kadr.addEventListener('scroll', function () {
      if (czekaKropki) return;
      czekaKropki = true;
      window.requestAnimationFrame(function () {
        czekaKropki = false;
        odswiezKropki();
      });
    }, { passive: true });

    // zmiana wariantu potrafi przebudować listę zdjęć
    new MutationObserver(function () {
      zbudujKropki();
      odswiezKropki();
    }).observe(kadr, { childList: true });
  }

  function start() {
    document.querySelectorAll('media-gallery').forEach(wepnij);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
